import { render, staticRenderFns } from "./marks-list.vue?vue&type=template&id=11f7ae8c&scoped=true&"
import script from "./marks-list.vue?vue&type=script&lang=js&"
export * from "./marks-list.vue?vue&type=script&lang=js&"
import style0 from "./marks-list.vue?vue&type=style&index=0&id=11f7ae8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f7ae8c",
  null
  
)

export default component.exports